import React, { Component } from 'react';
import { Grid, Col, Row } from 'react-bootstrap';
import Card from '../../../components/Card/Card';
import JqxGrid, { jqx } from "jqwidgets-scripts/jqwidgets-react-tsx/jqxgrid";
import _ from 'lodash';
import { dominio } from "../../../routes_backend/routes.jsx";
import Loading from '../../../views/Loading';
import Swal from 'sweetalert2';  // Importa SweetAlert2
const PALETTE = [
  '#A3E4D7','#AED6F1','#F9E79F','#F5B7B1','#D7BDE2',
  '#FAD7A0','#ABEBC6','#F5CBA7','#AED6F1','#F8C471'
];


// Hash simple y estable para strings
function hashString(str) {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = ((h << 5) - h) + str.charCodeAt(i);
    h |= 0; // 32-bit
  }
  return Math.abs(h);
}

// Color de texto según contraste
function textColorFor(bgHex) {
  // hex -> r,g,b
  const hex = bgHex.replace('#','');
  const r = parseInt(hex.substring(0,2), 16);
  const g = parseInt(hex.substring(2,4), 16);
  const b = parseInt(hex.substring(4,6), 16);
  // luminancia percibida
  const luminance = 0.2126*r + 0.7152*g + 0.0722*b;
  return luminance > 160 ? '#000000' : '#FFFFFF';
}

// Obtiene un color estable para cada WhsCode
function colorForWhs(whs) {
  if (!whs) return '#E0E0E0';
  const idx = hashString(String(whs)) % PALETTE.length;
  return PALETTE[idx];
}


const myGrid = React.createRef();

class EntregaCombustible extends Component {
  constructor() {
    super();
    this.state = {
      isLoading: false,
      message: '',
      expandedRow: null, // Guardar DocEntry de la fila expandida
      datos: [], // Usamos datos en lugar de source
      columns: [
        { text: 'DocEntry', datafield: 'DocEntry', width: '6%', cellsalign: 'center', align: 'center' },
        { text: '#Documento', datafield: 'DocNum', width: '6%' },
        { text: 'Socio', datafield: 'CardCode', width: '5%' },
        { text: 'Nombre', datafield: 'CardName', width: '10%' },
        {
  text: 'Almacen',
  datafield: 'WhsCode',
  width: '10%',
  cellsrenderer: function (row, columnfield, value, defaulthtml, columnproperties) {
    const bg = colorForWhs(value);
    const fg = textColorFor(bg);
    return '<div style="margin:4px; padding:4px; background-color:'+bg+'; color:'+fg+'; text-align:center; border-radius:4px;">'
           + (value ?? '') +
           '</div>';
  }
},
        { text: 'Fecha', datafield: 'DocDate', width: '10%', cellsformat: 'dd/MM/yyyy', align: 'center' },        
        { text: 'Comentario', datafield: 'Comments', width: '10%', align: 'center' },
        { text: 'Total Galones', datafield: 'totalCantidad', width: '7%', align: 'center' },
        { text: 'Vehículo', datafield: 'totalVehiculo', width: '5%', align: 'center', cellsalign: 'center' },

        { text: 'TaxDate', datafield: 'TaxDate', width: '5%', cellsformat: 'dd/MM/yyyy', align: 'center' },
        { text: 'Referencia', datafield: 'U_Referencia', width: '5%' },
        { text: 'Estado Combustible', datafield: 'U_EstadoCombustible', width: '10%' },
        {
          datafield: "Entregar", align: "center", width: "10%", editable: false, columntype: "button", cellclassname: "special",
		  buttonclick: (row) => {
			const dataRecord = myGrid.current.getrowdata(row);
			const { datos } = this.state;
		  
			// Buscar el registro correspondiente en los datos
			const selectedData = datos.find(item => item.DocEntry === dataRecord.DocEntry);
			if (!selectedData) {
			  console.log("No se encontró el registro correspondiente en los datos.");
			  return;
			}
		  
			let username = "";
			let password = "";
			const token = localStorage.getItem("token");
			const token_Data = JSON.parse(token);
			if (token_Data !== null) {
			  token_Data.forEach((element) => {
				username = element.usuarioSAP;
				password = element.contraseñaSAP;
			  });
			} else {
			  this.props.history.push("");
			  return;
			}
		  
			// Crear el JSON a enviar
			const jsonData = {
			  username,
			  password,
			  DocDate: dataRecord.DocDate,
			  DocDueDate: dataRecord.DocDueDate,
			  TaxDate: dataRecord.TaxDate,
			  CardCode: dataRecord.CardCode,
			  CardName: dataRecord.CardName,   
        Comments: dataRecord.Comments,  
			  DocumentLines: dataRecord.DocumentLines.map(detail => ({
				ItemCode: detail.ItemCode || "", // Validar que exista
				Quantity: parseFloat(detail.Quantity) || 0, // Validar que sea un número
				BaseEntry: parseInt(detail.DocEntry, 10) || 0, // Validar que sea un entero
				BaseType: 17, // Tipo de documento base
				WarehouseCode: detail.WhsCode || "", // Validar que exista
				LineNum: detail.LineNum
			  })),
			  U_Referencia: dataRecord.U_Referencia || "Sin referencia", // Valor por defecto
			  U_EstadoCombustible: dataRecord.U_EstadoCombustible || "Pendiente" // Valor por defecto
			};
			console.log(jsonData);
			
		  
			// Enviar los datos al servidor
			fetch(`${dominio}/EntregaCombustible`, {
			  method: 'POST',
			  headers: {
				'Content-Type': 'application/json',
			  },
			  body: JSON.stringify(jsonData),
			})
			  .then((res) => {
				if (!res.ok) {
				  throw new Error(`HTTP error! status: ${res.status}`);
				}
				return res.json();
			  })
			  .then((data) => {
				try {
				  const jsonResponse = JSON.parse(data.response_text);
				  if (data.error === "Error en la solicitud") {
					const errorMessage = jsonResponse?.error?.message?.value || "Mensaje de error no disponible";
					Swal.fire({
					  icon: 'error',
					  title: 'Error en la solicitud',
					  text: errorMessage,
					}).then(() => {
					  window.location.reload();
					});
				  } else {
					Swal.fire({
					  icon: 'success',
					  title: 'Entrega realizada exitosamente',
					  text: `Número de Documento: ${jsonResponse.DocNum}`,
					}).then(() => {
					  window.location.reload();
					});
				  }
				} catch (err) {
				  console.error("Error al analizar la respuesta:", err);
				  Swal.fire({
					icon: 'error',
					title: 'Error al procesar la respuesta',
					text: err.message || "Error desconocido",
				  });
				}
			  })
			  .catch((error) => {
				console.error("Error en la solicitud:", error);
				Swal.fire({
				  icon: 'error',
				  title: 'Error al enviar la solicitud',
				  text: error.message || "Error desconocido",
				});
			  });
		  },
		  
		  
		  
          cellsrenderer: function () {
            return "Entregar";
          }
        }
      ],
    };
  }

  componentDidMount() {
    this.fetchData();
  }



  fetchData = async () => {
    this.setState({ isLoading: true });
  
    try {
      const response = await fetch(`${dominio}/get_combustibleOV`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'API-Key': '756b057d-342f-43d2-ba24-f5d153703d76', // API Key
        },
      });
  
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      const data = await response.json();
      console.log(data);
      
      // Formatear los datos para que se adapten al formato esperado por el grid
      const formattedData = data.map(item => {
        // Total de cantidades por documento
        const totalCantidad = Array.isArray(item.DocumentLines)
          ? item.DocumentLines.reduce((sum, detail) => sum + Number(detail.Quantity), 0)
          : 0;
  
        // Valores únicos de U_Vehiculo
        const totalVehiculo = Array.isArray(item.DocumentLines)
          ? [...new Set(item.DocumentLines.map(detail => detail.U_Vehiculo))].join(', ')
          : '';
        const firstWhs = Array.isArray(item.DocumentLines) ? item.DocumentLines[0]?.WhsCode ?? null : null;

        return {
          DocEntry: item.DocEntry,
          DocNum: item.DocNum,
          CardCode: item.CardCode,
          CardName: item.CardName,
          WhsCode: firstWhs,
          DocDate: item.DocDate,
          DocDueDate: item.DocDueDate,
          TaxDate: item.TaxDate,
          U_Referencia: item.U_Referencia,
          U_EstadoCombustible: item.U_EstadoCombustible,
          Comments: item.Comments,
          totalCantidad, // Total de galones
          totalVehiculo, // Vehículos únicos
          DocumentLines: Array.isArray(item.DocumentLines)
            ? item.DocumentLines.map(detail => ({
                DocEntry: detail.DocEntry,
                Dscription: detail.Dscription,
                WhsCode: detail.WhsCode,
                ItemCode: detail.ItemCode,
                LineNum: detail.LineNum,
                Quantity: detail.Quantity,
                U_Destino: detail.U_Destino,
                U_GlsAuto: detail.U_GlsAuto,
                U_HorometroFin: detail.U_HorometroFin,
                U_HorometroIni: detail.U_HorometroIni,
                U_Kmcargado: detail.U_Kmcargado,
                U_Kmvacio: detail.U_Kmvacio,
                U_Numero_Doc: detail.U_Numero_Doc,
                U_Origen: detail.U_Origen,
                U_Piloto: detail.U_Piloto,
                U_PilotoId: detail.U_PilotoId,
                U_RendimientoObten: detail.U_RendimientoObten,
                U_Rutas: detail.U_Rutas,
                U_Total_Km: detail.U_Total_Km,
                U_Vehiculo: detail.U_Vehiculo,
              }))
            : [], // Asegurarse de que siempre sea un array
        };
      });
  
      // Actualizamos el estado con los datos formateados
      this.setState({
        datos: formattedData, // Aquí se usa datos en lugar de source
        isLoading: false,
      });
    } catch (error) {
      console.error('Error fetching data:', error);
      this.setState({
        isLoading: false,
        message: 'No hay despacho liquidado pendiente de entrega',
      });
    }
  };
  
  
  
  

  render() {
    const { isLoading, message, datos, columns } = this.state;

    return (
      <div className="content" style={{ textAlign: 'center', alignItems: 'center' }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Despacho Combustible"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
                    {isLoading ? (
                      <Loading />
                    ) : message ? (
                      <p style={{ color: 'red' }}>{message}</p>
                    ) : !_.isEmpty(datos) ? ( // Cambié source por datos aquí
                      <JqxGrid
                        ref={myGrid}
                        width="100%"
                        source={new jqx.dataAdapter({ localdata: datos, datatype: "array" })} // Usamos datos aquí
                        pageable={true}
                        autoheight={true}
                        sortable={true}
                        altrows={true}
                        enabletooltips={true}
                        editable={false}
                        columns={columns}
                      />
                    ) : (
                      'No data'
                    )}
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EntregaCombustible;
